"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadActivitiesSpreadsheet = void 0;
const core_1 = require("@zodios/core");
const zod_1 = require("zod");
const activitySheetSchema = zod_1.z.object({
    /** Contains the sheet data */
    data: zod_1.z.array(zod_1.z.array(zod_1.z.union([zod_1.z.string(), zod_1.z.number()]))),
    name: zod_1.z.string(),
    sheetId: zod_1.z.union([zod_1.z.string(), zod_1.z.number()]),
    sheetIndex: zod_1.z.number(),
});
const activitySheetPayloadSchema = zod_1.z.object({
    spreadsheetId: zod_1.z.string(),
    spreadsheetName: zod_1.z.string(),
    whatsapp: zod_1.z.string(),
    data: zod_1.z.array(activitySheetSchema),
});
exports.loadActivitiesSpreadsheet = (0, core_1.makeEndpoint)({
    method: "post",
    path: "/private-scripts/load-activities-spreadsheet",
    alias: "loadActivitiesSpreadsheet",
    parameters: [
        {
            name: "body",
            type: "Body",
            schema: activitySheetPayloadSchema,
        },
    ],
    response: zod_1.z.object({ success: zod_1.z.boolean() }),
});
//# sourceMappingURL=loadActivitiesSpreadsheet.js.map